import React from "react";

function Button({
    label,
    className,
    handleClick,
    disabled = false,
    customStyle = {},
    type = "button",
    fullWidth = false,
    icon = null,
    iconPosition = "left",
}) {
    const style = {
        padding: customStyle.padding || "0.5rem 1.25rem",
        borderRadius: customStyle.borderRadius || "0.35rem",
        border: customStyle.border || "none",
        color: customStyle.color || "grey",
        backgroundColor: customStyle.backgroundColor ,
        display: "flex",
        alignItems: "center",
        justifyContent: iconPosition === "left" ? "flex-start" : "space-between",
        gap: "1rem",
        width: fullWidth ? "100%" : "auto",
        cursor: "pointer",
        fontSize: "0.9rem",
        ...customStyle,
    };

    return (
        <button
            className={className}
            type={type}
            style={style}
            onClick={handleClick}
            disabled={disabled}>
            {icon && iconPosition === "left" && (
                <span style={{ display: "flex" }}>{icon}</span>
            )}
            {label}
            {icon && iconPosition === "right" && <span>{icon}</span>}
        </button>
    );
}

export default Button;
